import en from '@/locales/en.json';
import nl from '@/locales/nl.json';
import { usePrimeVue } from 'primevue/config';

export default {
  data() {
    return {
      localeDict: {
        nl: nl,
        en: en,
      },
    };
  },
  methods: {
    updatePrimeVueLocale(locale) {
      const { config } = usePrimeVue();

      config.locale = this.localeDict[locale].primevue;
    },
  },
};
